import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicItemBaseComponent } from '@ups/xplat/dynamic-render';

@Component({
  selector: 'ups-dynamic-button',
  template: `
    <div class="dynamic-field-container" [class.selected]="config?.selected">
      <div class="dynamic-field form-button" [formGroup]="group">
        @if (config?.options?.showCancelButton) {
          <button class="k-button" (click)="cancel()">Clear</button>
        }
        @if (config?.options?.showDeleteDraftButton) {
          <button class="k-button" (click)="showDeleteConfirm = true">
            Delete Draft
          </button>
        }
        @if (config?.options?.showDraftButton) {
          <button class="k-button" (click)="submit(true)">Save Draft</button>
        }
        <button
          [attr.name]="config.formControlName"
          class="k-button"
          [class.k-primary]="config?.options?.primary"
          (click)="submit()"
        >
          {{ config?.value }}
        </button>
      </div>
      @if (config?.isFormBuilder) {
        <div class="form-builder-options">
          <i
            class="fas fa-times ml-3 cursor-pointer c-red"
            (click)="delete()"
          ></i>
          <!-- <i class="fas fa-bars ml-3 cursor-grab "></i> -->
        </div>
      }
    </div>

    @if (showDeleteConfirm) {
      <ups-dynamic-delete-form-modal
        (closeModal)="showDeleteConfirm = false"
        (deleteDone)="dynamicService.formReviewDone$.next()"
      ></ups-dynamic-delete-form-modal>
    }
  `,
  styles: [
    `
      .form-button {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
      }
      .form-button button {
        height: 100%;
        min-width: 25%;
      }
    `,
  ],
  // WI 35584: base-class marks cover async writes; ngDoCheck covers in-place config flags.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicButtonComponent extends DynamicItemBaseComponent {
  showDeleteConfirm = false;
}
